module.exports = __webpack_public_path__ + "static/media/Gor 2018.11.03-5psd.5fea8b53.webp";